import { render } from "./BaseContainer.vue?vue&type=template&id=a8389f0a&scoped=true&ts=true"
import script from "./BaseContainer.vue?vue&type=script&lang=ts"
export * from "./BaseContainer.vue?vue&type=script&lang=ts"

import "./BaseContainer.vue?vue&type=style&index=0&id=a8389f0a&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8389f0a"]])

export default __exports__